import { useEffect, useState } from 'react';
import api from '../lib/api';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import CommsOverview from '../components/comms/CommsOverview';
import CampaignsTab from '../components/comms/CampaignsTab';
import SentCampaignsTab from '../components/comms/SentCampaignsTab';
import SubscribersTab from '../components/comms/SubscribersTab';
import TemplatesTab from '../components/comms/TemplatesTab';

export default function CommunicationsPage() {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    api.get('/comms/meta').then((r) => setMeta(r.data)).catch(() => {});
  }, []);

  if (!meta) return <div className="p-8 text-sm text-slate-500" data-testid="comms-loading">Loading…</div>;

  return (
    <div className="space-y-6" data-testid="communications-page">
      <Tabs defaultValue="overview">
        <TabsList data-testid="comms-tabs">
          <TabsTrigger value="overview" data-testid="tab-overview">Overview</TabsTrigger>
          <TabsTrigger value="campaigns" data-testid="tab-campaigns">Campaigns</TabsTrigger>
          <TabsTrigger value="sent" data-testid="tab-sent">Sent Campaigns</TabsTrigger>
          <TabsTrigger value="subscribers" data-testid="tab-subscribers">Newsletter Subscribers</TabsTrigger>
          <TabsTrigger value="templates" data-testid="tab-templates">Templates</TabsTrigger>
        </TabsList>
        <TabsContent value="overview"><CommsOverview /></TabsContent>
        <TabsContent value="campaigns"><CampaignsTab meta={meta} /></TabsContent>
        <TabsContent value="sent"><SentCampaignsTab meta={meta} /></TabsContent>
        <TabsContent value="subscribers"><SubscribersTab meta={meta} /></TabsContent>
        <TabsContent value="templates"><TemplatesTab meta={meta} /></TabsContent>
      </Tabs>
    </div>
  );
}
